


import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import Button from '../../components/shared/Button'
import SmallSpinner from '../../components/shared/spinners/SmallSpinner'
import { getCurrentYakitFiyat, getDefaultMaliyetHesabi, getDefaultMaliyetHesabiCostCalculate, getKdv, updateDefaultMaliyetHesabi } from '../../features/calc/calcSlice'
import getCurrentDate from '../../helper/getCurrentDate'
import SeferMaliyetTable from '../../components/seferMaliyetBilgileri/SeferMaliyetTable'
import CostCalculateResponse1 from '../../components/seferMaliyetBilgileri/CostCalculateResponse1'
import InputText from '../../components/shared/input/new/InputText'
import formatConverter from '../../helper/formatConverter'
const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 10px;
            margin: 0 30px;
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            margin-bottom: 110px;
            width: calc(100% - 60px);
            color: ${({theme}) => theme.mainTextColor};


            .op-container{
              margin: 20px 0;
              display: flex;
              flex-direction: column;
              gap: 20px;

              .desc{
                font-size: 12px;
                font-weight: var(--font-weight-lg);
              }

              .input-wrapper{
                display: flex;
                gap: 60px;

                .data-item{
                  border: 1px solid ${({theme}) => theme.mainTextColor};
                  padding: 5px 10px;
                  height: 40px;
                  font-size: var(--font-size-sm);
                  font-weight: var(--font-weight-lg);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px;
                }

              }
            }

        }

        .btn-container{
          width: calc(100% - 300px);
          display: flex;
          justify-content: center;
          gap: 40px;
          padding: 20px 0;
          position: fixed;
          left: 300px;
          bottom: 0;
          background-color: ${({ theme }) => theme.mainBgColor};
          border-top: 1px solid ${({ theme }) => theme.mainBorderColor};
        }
    }
`

const SeferMaliyetBligileri = () => {

    const {
      constantSeferMaliyetData,
      seferMaliyetData,
      isloadingUpdateDefaultMaliyetHesabi,
      yakitData,
      costCalculateDataList,
      isLoadingGetDefaultMaliyetHesabiCostCalculate
    } = useSelector(state => state.calc)

    const dispatch = useDispatch()

    const [kmData, setKmData] = useState("")
    

    useEffect(() => {
      dispatch(getDefaultMaliyetHesabi())
      dispatch(getCurrentYakitFiyat())
      dispatch(getKdv())
    },[])

    const handleSubmit = () => {
      // constantSeferMaliyetData, seferMaliyetData
      const filtered = seferMaliyetData.filter((item, i) => {
        const jsonString1 = JSON.stringify(item);
        const jsonString2 = JSON.stringify(constantSeferMaliyetData[i]);
        return jsonString1 !== jsonString2
      })

      const updatedFiltered = filtered.map((item) => {
        return {...item, olusturulmaTarihi: getCurrentDate(), arsiveAlinmaTarihi:getCurrentDate() }
      })

      dispatch(updateDefaultMaliyetHesabi(updatedFiltered))
    }

    useEffect(() => {
      if(kmData > 0){
        dispatch(getDefaultMaliyetHesabiCostCalculate(parseInt(kmData)))
      }
      
    },[kmData])

    if(!seferMaliyetData){
      return null
    }

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Sefer Maliyet Hesaplama Bilgileri"} position="sticky"/>
        <div className="content">
          <SeferMaliyetTable/>
          <div className="op-container">
            <p className="desc">Km bilgisini girin ve hesaplama sonuçlarını görüntüleyin</p>
            
            <div className="input-wrapper">
              <InputText data={kmData} setData={(e) => setKmData(e.target.value.replace(/[^0-9]/g, ''))} name={"kmData"} labelText={"Km"} inputWidth={"280px"} />
              <div className="data-item">Gün: {isLoadingGetDefaultMaliyetHesabiCostCalculate ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : formatConverter(costCalculateDataList[0]?.gun || "")}</div>
              <div className="data-item">Güncel Yakıt Fiyatı: {formatConverter(yakitData)} TL</div>
            </div>
          </div>

          {
            !isLoadingGetDefaultMaliyetHesabiCostCalculate && costCalculateDataList.length > 0 &&
            <CostCalculateResponse1/>
          }

          {
            isLoadingGetDefaultMaliyetHesabiCostCalculate &&
            <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/>
          }
          
        </div>

        <div className="btn-container">
            <Button type='button' text={isloadingUpdateDefaultMaliyetHesabi ? <SmallSpinner size='16px' color='#fff' bgColor='var(--color-main)'/> :"Kaydet / Güncelle"} background={"var(--color-main)"} color={"#fff"} handleClick={handleSubmit} padding='0 10px' width='280px' />
        </div>

      </div>
    </Container>
  )
}

export default SeferMaliyetBligileri